const getNonBlankString = (value) => {
    if (typeof value !== 'string') {
        return undefined;
    }
    return value.trim() || undefined;
};
// Classify a Rich Maps transition value (typeCode or name) into a stairs /
// elevator translation key. Returns undefined when it can't be classified.
const getTransitionTranslationKey = (value) => {
    var _a;
    const normalized = (_a = getNonBlankString(value)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (!normalized) {
        return undefined;
    }
    if (normalized.includes('stair')) {
        return 'floor.directions.stairs';
    }
    if (normalized.includes('elevator') || normalized.includes('lift')) {
        return 'floor.directions.elevator';
    }
    return undefined;
};
/**
 * Resolve the localized label for the connector a multifloor route uses.
 *
 * Per the Rich Maps team, the authoritative source for the transition is
 * `transitionInfo` (NOT `portalName`). We classify it as stairs vs elevator
 * from `transitionInfo.typeCode` first, then its `name`. A route with route
 * data present but no classifiable transition falls back to "Elevator". We
 * intentionally never surface a generic "Connector" label.
 *
 * Returns `null` when there is NO route data yet (the SDK
 * `NAVIGATION_DATA_LOAD` callback hasn't fired) so callers can show a loading
 * state instead of prematurely flashing the Elevator fallback.
 */
export const getLocalizedNavigationConnectorName = (directionsData, t) => {
    var _a, _b;
    const rawFeatures = directionsData === null || directionsData === void 0 ? void 0 : directionsData.features;
    const features = Array.isArray(rawFeatures) ? rawFeatures : [];
    // No route data yet -> unresolved (let the caller render a loading state).
    if (features.length === 0) {
        return null;
    }
    const transitionFeature = features.find((feature) => {
        var _a;
        const transitionInfo = (_a = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _a === void 0 ? void 0 : _a.transitionInfo;
        return Boolean(getNonBlankString(transitionInfo === null || transitionInfo === void 0 ? void 0 : transitionInfo.typeCode) ||
            getNonBlankString(transitionInfo === null || transitionInfo === void 0 ? void 0 : transitionInfo.name));
    });
    const transitionInfo = (_a = transitionFeature === null || transitionFeature === void 0 ? void 0 : transitionFeature.properties) === null || _a === void 0 ? void 0 : _a.transitionInfo;
    const translationKey = (_b = getTransitionTranslationKey(transitionInfo === null || transitionInfo === void 0 ? void 0 : transitionInfo.typeCode)) !== null && _b !== void 0 ? _b : getTransitionTranslationKey(transitionInfo === null || transitionInfo === void 0 ? void 0 : transitionInfo.name);
    if (translationKey === 'floor.directions.stairs') {
        return t('floor.directions.stairs');
    }
    // Elevator for explicit elevator/lift transitions AND as the sole fallback
    // when the transition is unknown or absent.
    return t('floor.directions.elevator');
};
